module.exports = __webpack_public_path__ + "static/media/login-vb-shield-text-small-light.a45addb4.png";